/* unplugin-vue-components disabled */import { render } from "./PromocodeCampaignExpandedCard.vue?vue&type=template&id=16bf93fa&scoped=true&ts=true"
import script from "./PromocodeCampaignExpandedCard.vue?vue&type=script&lang=ts"
export * from "./PromocodeCampaignExpandedCard.vue?vue&type=script&lang=ts"

import "./PromocodeCampaignExpandedCard.vue?vue&type=style&index=0&id=16bf93fa&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bf93fa"]])

export default __exports__